import { TSelectedFilterValue, TTableColumns } from '@/components/table/types';
import { serializeDataByParams } from '@/helpers/dataHelpers';
import { formatingColumns } from '@/helpers/tableHelpers';
import { splitUrlParamsValue } from '@/helpers/urlParamsHelpers';
import { TDropDownItem, TDropDownList } from '@/types';
import { cloneDeep } from 'lodash';

interface ITableColumnData {
  getColumns: () => TTableColumns;
  formating: () => ITableColumnData;
  setItems: (items: TDropDownList, field: string) => TTableColumns;
  setFilterValues: (item: TSelectedFilterValue) => TTableColumns;
}

interface ITestTableColumnData {
  getData: (count: number | null) => Array<any>;
}

export class TableColumnsData implements ITableColumnData {
  private _columns;

  constructor(columns: TTableColumns) {
    this._columns = columns;
  }

  public getColumns() {
    return this._columns;
  }

  public formating() {
    this._columns = formatingColumns(this._columns);
    return this;
  }

  public setItems(items, field) {
    try {
      const column = this._columns.find((column) => column.field === field);

      if (column && items.length) {
        column.items = items;
        const tempItems = serializeDataByParams(items, 'value');
        for (const item of column.filterValues) {
          if (tempItems[item.value]) {
            item.label = tempItems[item.value].label;
          }
        }
      }
    } catch (err) {
      console.error('TableColumnsData - setItems: ', err);
    }

    return cloneDeep(this._columns);
  }

  public setFilterValues(item) {
    let tempItem = {} as TDropDownItem;

    try {
      const [field, value] = splitUrlParamsValue(item.value);

      for (const column of this._columns) {
        if (column.field === field) {
          tempItem = {
            label: value,
            value,
          };

          if (column?.items?.length) {
            const items = serializeDataByParams(column.items, 'value');

            if (items[value]) {
              tempItem = {
                label: items[value].label,
                value: items[value].value,
              };
            }
          }

          column.filterValues.push(tempItem);
        }
      }
    } catch (err) {
      console.error('TableColumnsData - setFilterValues: ', err);
    }

    return cloneDeep(this._columns);
  }
}

export class TestTableColumnsData
  extends TableColumnsData
  implements ITestTableColumnData
{
  private _data;

  constructor(columns, data = () => {}) {
    super(columns);
    this._data = data;
  }

  public getData(count: number | null = null) {
    if (count !== null) {
      return this._data(count);
    }

    return this._data();
  }
}
